/*********** Reduceres defined here *********/

import { persistCombineReducers } from 'redux-persist';
import storage from 'redux-persist/es/storage'; // default: localStorage if web, AsyncStorage if react-native
// import storageSession from 'redux-persist/lib/storage/session'
// reducers
import user from './modules/user';
import loader from './modules/loader';
import search from './modules/search';
import chats from './modules/chats'
import call_modal from './modules/video_audio_modal';

const userPersistConfig = {
    key: 'admin-app',
    storage: storage,
    blacklist: ['loader'],
};

const appReducer = persistCombineReducers(userPersistConfig, {
    loader,
    user,
    search,
    chats,
    call_modal
});

const rootReducer = (state, action) => {
    if (action.type === 'LOG_OUT') {
        storage.removeItem('persist:admin-app');
        state = undefined;
    }
    return appReducer(state, action);
};

export default rootReducer;
